import { ArrowUpRight } from "lucide-react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { Reveal } from "@/components/site/Reveal";
import { ListSignup } from "@/components/site/ListSignup";
import { WIX_SHOP_URL } from "@/data/site";

// Styled shell that links out to a real storefront. Jenn doesn't sell merch
// yet (she wants to — "future merch", "increase ... sales in merch"), so
// with WIX_SHOP_URL null this is a "merch coming soon" page pointing at the
// list (merch alerts are one of her list incentives). Routed at /shop but
// kept out of NAV_LINKS until a store exists.
export default function Shop() {
  return (
    <div className="starfield relative min-h-screen">
      <div className="ambient-tint-cycle fixed inset-0 z-0" style={{ animationDelay: "-14s" }} />
      <Navbar />
      <main className="relative z-10 flex min-h-screen flex-col items-center justify-center px-6 text-center">
        <Reveal>
          <span className="overline">Shop</span>
          <h1 className="font-display mt-5 text-4xl text-[var(--sm-text)] sm:text-5xl">Merch &amp; Music</h1>
          <p className="font-body mt-4 max-w-md text-sm font-light text-white/60">
            {WIX_SHOP_URL ? "Everything lives on Jenn's storefront." : "Merch is on the way. Get on the list to hear about the first drop."}
          </p>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="mt-10">
            {WIX_SHOP_URL ? (
              <a
                href={WIX_SHOP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 rounded-full border border-white/20 px-7 py-3 font-accent text-xs uppercase tracking-[0.22em] text-white/75 transition-all duration-300 hover:border-[var(--sm-gold)]/60 hover:text-[var(--sm-gold-light)]"
              >
                Visit the Shop <ArrowUpRight size={15} />
              </a>
            ) : (
              <ListSignup />
            )}
          </div>
        </Reveal>
      </main>
      <Footer />
    </div>
  );
}
